import { useMemo, useState } from "react";
import { SCORECARD_VOCAB } from "@shared/scorecard";
import type {
  FieldReannotationParams,
  ListBatchJobItemsParams,
} from "../../../../../lib/corpusApi";

export interface UseFieldReannotationFiltersResult {
  /** The labels the field can take, for the old/new label filters. */
  labelOptions: string[];
  /** Narrows the list to documents whose AI label was this before the re-annotation. */
  oldLabel: string | null;
  setOldLabel: (label: string | null) => void;
  /** Narrows the list to documents whose AI label is this after the re-annotation. */
  newLabel: string | null;
  setNewLabel: (label: string | null) => void;
  /** The filters in the form the items list takes. */
  apiFilters: Pick<ListBatchJobItemsParams, "fieldReannotation">;
}

/** The old-label and new-label filters of a field_reannotation list; they combine. */
export function useFieldReannotationFilters(
  field: FieldReannotationParams["field"]
): UseFieldReannotationFiltersResult {
  const [oldLabel, setOldLabel] = useState<string | null>(null);
  const [newLabel, setNewLabel] = useState<string | null>(null);

  const labelOptions = useMemo(() => [...(SCORECARD_VOCAB[field] ?? [])], [field]);

  const apiFilters = useMemo(
    () =>
      oldLabel || newLabel
        ? {
            fieldReannotation: {
              ...(oldLabel ? { oldLabel } : {}),
              ...(newLabel ? { newLabel } : {}),
            },
          }
        : {},
    [oldLabel, newLabel]
  );

  return { labelOptions, oldLabel, setOldLabel, newLabel, setNewLabel, apiFilters };
}
